module.exports = __webpack_public_path__ + "img/180.36fe2b2e.jpg";